export default {
  atterbergLimit: {
    ASTM_D4318: { label: 'ASTM D4318 - Atterberg Limits', value: 'ASTM D4318' },
  },
  liquidLimit: {
    AS_1289_3_1_1: { label: 'AS 1289.3.1.1 - Liquid Limit', value: 'AS 1289.3.1.1' },
    AS_1289_3_1_2: { label: 'AS 1289.3.1.2 - Liquid Limit', value: 'AS 1289.3.1.2' },
    AS_1289_3_9_1: { label: 'AS 1289.3.9.1 - Liquid Limit', value: 'AS 1289.3.9.1' },
    AS_1289_3_9_2: { label: 'AS 1289.3.9.2 - Liquid Limit', value: 'AS 1289.3.9.2' },
  },
  sandReplacement: {
    AS_1289_5_3_1: { label: 'AS 1289.5.3.1 - Sand Replacment (Sand Cone)', value: 'AS 1289.5.3.1' },
    AS_1289_5_3_2: { label: 'AS 1289.5.3.2 - Sand Replacment (Sand Pouring can)', value: 'AS 1289.5.3.2' },
  },
  waterReplacement: { AS_1289_5_3_5: { label: 'AS 1289.5.3.5 - Water Replacement', value: 'AS 1289.5.3.5' } },
  nuclearFieldDensity: {
    AS_1289_5_8_1: { label: 'AS 1289.5.8.1 - Nuclear Field Density', value: 'AS 1289.5.8.1' },
  },
  particleDensity: {
    AS_1289_3_5_1: { label: 'AS 1289.3.5.1 - Particle Density', value: 'AS 1289.3.5.1' },
    BS_1377_2_Clause_9_2: { label: 'BS 1377-2 Clause 9.2 - Particle Density', value: 'BS 1377-2 Clause 9.2' },
    BS_EN_ISO_17892_3: { label: 'BS EN ISO 17892-3 - Particle Density', value: 'BS EN ISO 17892-3' },
    ISO_17892_3: { label: 'ISO 17892-3 - Particle Density', value: 'ISO 17892-3' },
  },

  maximumDryDensity: {
    AS_1289_5_1_1: { label: 'AS 1289.5.1.1 - Standard Maximum Dry Density', value: 'AS 1289.5.1.1' },
    AS_1289_5_2_1: { label: 'AS 1289.5.1.1 - Modified Maximum Dry Density', value: 'AS 1289.5.2.1' },
  },
  moistureContent: {
    AS_1289_2_1_1: { label: 'AS 1289.2.1.1 - Moisture Content', value: 'AS 1289.2.1.1' },
    AS_1289_2_1_2: { label: 'AS 1289.2.1.2 - Moisture Content', value: 'AS 1289.2.1.2' },
    AS_1289_2_1_4: { label: 'AS 1289.2.1.4 - Moisture Content', value: 'AS 1289.2.1.4' },
    AS_1289_2_1_5: { label: 'AS 1289.2.1.5 - Moisture Content', value: 'AS 1289.2.1.5' },
    AS_1289_2_1_6: { label: 'AS 1289.2.1.6 - Moisture Content', value: 'AS 1289.2.1.6' },
    ASTM_D2216: { label: 'ASTM D2216 - Moisture Content', value: 'ASTM D2216' },
    AASHTO_T_265: { label: 'AASHTO T 265 - Moisture Content', value: 'AASHTO T 265' },
    BS_1377_2_1990_Clause3_2: {
      label: 'BS 1377-2:1990 Clause 3.2 - Moisture Content',
      value: 'BS 1377-2:1990 Clause 3.2',
    },
    BS_EN_ISO_17892_1: {
      label: 'BS EN ISO 17892-1 - Water Content',
      value: 'BS EN ISO 17892-1',
    },
    ISO_17892_1: {
      label: 'ISO 17892-1 - Water Content',
      value: 'ISO 17892-1',
    },
  },
  moistureContentCorrelation: {
    AS_1289_2_3_1: { label: 'AS 1289.2.3.1 - Moisture Content Correlation', value: 'AS 1289.2.3.1' },
  },
  psd: {
    BS_EN_ISO_17892_4: { label: 'BS EN ISO 17892-4 - Particle Size Distribution', value: 'BS EN ISO 17892-4' },
  },
  psdSieveAnalysis: {
    AS_1289_3_6_1: { label: 'AS 1289.3.6.1 - Grading', value: 'AS 1289.3.6.1' },
    AS_1289_3_6_3: { label: 'AS 1289.3.6.3 - Grading - Hydrometer', value: 'AS 1289.3.6.3' },
    ASTM_C136: { label: 'ASTM C136 - Sieve Analysis', value: 'ASTM C136' },
    ASTM_D6913: { label: 'ASTM D6913 - Sieve Analysis', value: 'ASTM D6913' },
    AASHTO_T_27: { label: 'AASHTO T 27 - Sieve Analysis', value: 'AASHTO T 27' },
    ARIZ_201e: { label: 'ARIZ 201e - Sieve Analysis', value: 'ARIZ 201e' },
    BS_EN_ISO_17892_4: { label: 'BS EN ISO 17892-4 Clause 5.2 - Sieve Analysis', value: 'BS EN ISO 17892-4 Cl 5.2' },
  },
  specificGravity: {
    AASHTO_T_85: { label: 'AASHTO T 85 - Specific Gravity (Coarse)', value: 'AASHTO T 85' },
    AASHTO_T_100: { label: 'AASHTO T 100 - Specific Gravity (Soil Solids)', value: 'AASHTO T 100' },
    ASTM_C127: { label: 'ASTM C127 - Specific Gravity (Coarse)', value: 'ASTM C127' },
    ASTM_D854: { label: 'ASTM D854 - Specific Gravity (Soil Solids)', value: 'ASTM D854' },
    ASTM_C127_D854: { label: 'ASTM C127 and ASTM D854', value: 'ASTM C127 and ASTM D854' },
  },
  sandConeFieldDensity: { AS1289_5_3_1: { label: 'AS 1289.5.3.1 - Sand Cone Field Density', value: 'AS 1289.5.3.1' } },
  binderContent: { AS_2891_3_2: { label: 'AS 2891.3.2 - Binder Content', value: 'AS 2891.3.2' } },
  bitumenContent: {
    AS_2891_3_1: { label: 'AS 2891.3.1 - Bitumen Content', value: 'AS 2891.3.1' },
    AS_2891_3_3: { label: 'AS 2891.3.3 - Bitumen Content', value: 'AS 2891.3.3' },
  },
};
